// src/utils/scroll-lock.js
const $body = document.querySelector("body");
let scrollPosition = 0;

export default {
  enable() {
    scrollPosition = window.pageYOffset;
    $body.style.overflow = "hidden";
    $body.style.position = "fixed";
    $body.style.top = `-${scrollPosition}px`;
    $body.style.left = `0px`;
    $body.style.right = `0px`;
    $body.style.bottom = `0px`;
    $body.style.width = "100%";
  },
  disable() {
    $body.style.removeProperty("overflow");
    $body.style.removeProperty("position");
    $body.style.removeProperty("top");
    $body.style.removeProperty("left");
    $body.style.removeProperty("right");
    $body.style.removeProperty("width");
    $body.style.removeProperty("bottom");
    window.scrollTo(0, scrollPosition);
  },
};
